import { render } from "./UenoScreen.vue?vue&type=template&id=bd62a096&scoped=true&ts=true&lang=pug"
import script from "./UenoScreen.vue?vue&type=script&lang=ts"
export * from "./UenoScreen.vue?vue&type=script&lang=ts"

import "./UenoScreen.vue?vue&type=style&index=0&id=bd62a096&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd62a096"]])

export default __exports__